import React, { Component } from "react";
import _ from "lodash";
import { Mutation, Query } from "react-apollo";
import gql from "graphql-tag";
import XLSX from "xlsx";
import csv from "csvtojson";
import { connect } from "react-redux";
import { ordersByShipmentId } from "../../queries/orders";
import { toast } from "react-toastify";
import { Box } from "reflexbox";
import { Modal } from "office-ui-fabric-react/lib/Modal";
import { PrimaryButton, ActionButton, DefaultButton } from "office-ui-fabric-react/lib/Button";

import { schemaIPH } from "../../schemas/schema_IPH";
import { schemaIPH_CSV } from "../../schemas/schema_IPH_CSV";
import { schemaKN } from "../../schemas/schema_KN";

import { countrysMapping } from "../../schemas/country_mapping";
import Dropzone from "react-dropzone";
import { DetailsList, Selection, ConstrainMode } from "office-ui-fabric-react/lib/DetailsList";
import { ChoiceGroup } from "office-ui-fabric-react/lib/ChoiceGroup";
import Select from "react-select";

class ImportTransitDialog extends Component {
  constructor() {
    super();

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({ selectedItems: this._selection.getSelection() });
      }
    });

    this.state = {
      schema: "",
      schemaKey: "",
      isModalVisible: false,
      data: [],
      selectedItems: [],
      buyerId: ""
    };
  }

  toggleDialog = () => {
    this.setState({ isModalVisible: true });
  };

  dismissDialog = () => {
    this.setState({
      isModalVisible: false,
      data: [],
      selectedItems: [],
      schemaKey: "",
      schema: ""
    });
  };

  clearForm = () => {
    this.setState({
      data: [],
      selectedItems: [],
      schemaKey: "",
      schema: ""
    });
  };

  handleSchemaSelect = (e, option) => {
    if (option.key === "iph") {
      this.setState({ schemaKey: option.key, schema: schemaIPH });
    } else if (option.key === "kn") {
      this.setState({ schemaKey: option.key, schema: schemaKN });
    } else if (option.key === "iph_csv") {
      this.setState({ schemaKey: option.key, schema: schemaIPH_CSV });
    }
    return;
  };

  selectBuyer = value => {
    this.setState({ buyerId: value });
  };

  onDrop = acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;

      reader.onload = () => {
        const bstr = reader.result;

        /* Parse data */
        const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        let data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        let parsedData = _.chain(data)
          // cut anything langer then defined schema
          .map(a => _.slice(a, 0, this.state.schema.mapping.length))
          // map parsed values to our schema keys
          .map(a => _.zipObject(_.values(this.state.schema.mapping), a))
          // replace country code with our schema values
          .map(e => {
            let index = _.findIndex(countrysMapping, v => v.oldValue === e.countryId);
            if (index > -1) {
              e.countryId = countrysMapping[index].newValue;
            }
            return e;
          })
          .value();

        this.setState({
          data: _.slice(parsedData, this.state.schema.defaults.headerRows) // slice headers
        });
      };
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.readAsBinaryString(file);
    });
  };

  onDropCsv = acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();
      reader.onload = () => {
        const bstr = reader.result;
        csv({ delimiter: ";" })
          .fromString(bstr)
          .on("csv", (csvRow, rowIndex) => {
            let parsedData = _.zipObject(_.values(this.state.schema.mapping), csvRow);
            let index = _.findIndex(countrysMapping, v => v.oldValue === parsedData.countryId);
            if (index > -1) {
              parsedData.countryId = countrysMapping[index].newValue;
            }
            this.setState({ data: [...this.state.data, parsedData] });
          })
          .on("done", () => { });
      };
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.readAsBinaryString(file);
    });
  };

  render() {
    const { data } = this.state;

    return (
      <div>
        <ActionButton
          iconProps={{ iconName: "Import" }}
          title="Import orders from exel files"
          onClick={this.toggleDialog}
        />
        <Modal
          isOpen={this.state.isModalVisible}
          onDismiss={this.dismissDialog}
          isBlocking={false}
          containerClassName="modalImport-container"
        >
          <Box flex align="center" justify="space-between" style={{ minHeight: "50px", background: "#bddded" }}>
            <Box style={{ fontSize: "large" }} pl={2}>
              Import transit orders
            </Box>
            <Box pr={1}>
              <ActionButton iconProps={{ iconName: "ChromeClose" }} onClick={this.dismissDialog} />
            </Box>
          </Box>
          <Box flex ml={2} mt={2}>
            <Box w={0.1}>
              <ChoiceGroup
                selectedKey={this.state.schemaKey}
                options={[
                  {
                    key: "iph",
                    text: "IP Handlers"
                  },
                  {
                    key: "iph_csv",
                    text: "IP Handlers CSV file"
                  },
                  {
                    key: "kn",
                    text: "Kuhne Nagel"
                  }
                ]}
                label="Select import schema"
                onChange={this.handleSchemaSelect}
              />
              {this.state.schemaKey && (
                <div>
                  <Query query={SELECT_BUYER}>
                    {({ loading, error, data }) => {
                      if (loading) return "Loading...";
                      if (error) return `Error! ${error.message}`;
                      return (
                        <Box mt={1}>
                          <Select
                            options={data.allRelations.nodes.map(buyer => ({
                              label: buyer.name,
                              value: buyer.id
                            }))}
                            onChange={this.selectBuyer}
                            value={this.state.buyerId}
                            placeholder="select buyer"
                            simpleValue
                          />
                        </Box>
                      );
                    }}
                  </Query>

                  <Box mt={1}>
                    <Dropzone
                      onDrop={this.state.schemaKey !== "iph_csv" ? this.onDrop : this.onDropCsv}
                      multiple={false}
                      style={style}
                    >
                      Drop exel file here
                    </Dropzone>
                  </Box>
                  <Box flex mt={1}>
                    <DefaultButton text="Clean" onClick={this.clearForm} />
                    {this.state.selectedItems.length > 0 && (
                      <Mutation mutation={CREATE_ORDER}>
                        {(createOrder, { loading, error, data }) => {
                          return (
                            <PrimaryButton
                              text="Accept"
                              onClick={e => {
                                e.preventDefault();
                                _.map(this.state.selectedItems, item => {
                                  let buyerId = this.state.buyerId ? this.state.buyerId : null;
                                  let { flight, boxesControle, awb, hawb } = item;
                                  let countryId = parseInt(item.countryId, 10)
                                  let packingCode = item && item.packingCode ? item.packingCode.toUpperCase() : '';
                                  let boxes = parseInt(item.boxes, 10);
                                  let brutto = parseInt(item.brutto.replace(/,(?=.*\.\d+)/g, ""), 10); // remove thousends separator
                                  let chargableWeight = parseInt(item.chargableWeight.replace(/,(?=.*\.\d+)/g, ""), 10); // remove thousends separator
                                  let shipmentId = this.props.shipment.id;
                                  let pickupDate = new Date(); // TODO use date from imported sheet
                                  let shipperId = this.props.shipment.relationId;
                                  let { sellerId, loadAtId, packingId, cargoTypeId } = this.state.schema.defaults;
                                  createOrder({
                                    refetchQueries: [
                                      {
                                        query: ordersByShipmentId,
                                        variables: { id: shipmentId }
                                      }
                                    ],
                                    variables: {
                                      shipmentId,
                                      shipperId,
                                      buyerId,
                                      cargoTypeId,
                                      packingCode,
                                      packingId,
                                      boxes,
                                      boxesControle,
                                      brutto,
                                      chargableWeight,
                                      awb,
                                      hawb,
                                      flight,
                                      countryId,
                                      pickupDate,
                                      sellerId,
                                      loadAtId
                                    }
                                  })
                                    .then(response => {
                                      toast.success(`Imported ! order id:  ${response}`);
                                    })
                                    .catch(err => {
                                      toast.error(`${err}`);
                                    });
                                });
                                this.dismissDialog();
                              }}
                            />
                          );
                        }}
                      </Mutation>
                    )}
                  </Box>
                </div>
              )}
            </Box>
            {data.length > 0 && (
              <Box auto ml={1}>
                <div data-is-scrollable="true">
                  <DetailsList
                    items={data}
                    setKey="import"
                    compact
                    selection={this._selection}
                    constrainMode={ConstrainMode.unconstrained}
                  />
                </div>
              </Box>
            )}
          </Box>
        </Modal>
      </div>
    );
  }
}

const style = {
  height: 50,
  width: 120,
  border: "dashed 2px #999",
  borderRadius: 5,
  position: "relative",
  cursor: "pointer"
};

const SELECT_BUYER = gql`
  query allRelations {
    allRelations(orderBy: NAME_ASC, condition: { role: "buyer" }) {
      nodes {
        id
        name
      }
    }
  }
`;

const CREATE_ORDER = gql`
  mutation(
    $shipmentId: Int
    $sellerId: Int
    $loadAtId: Int
    $buyerId: Int
    $shipperId: Int
    $packingCode: String
    $packingId: Int
    $boxes: Int
    $boxesControle: String 
    $brutto: Int
    $netto: Int
    $chargableWeight: Int
    $awb: String
    $hawb: String
    $flight: String
    $countryId: Int
    $amountPallets: BigFloat
    $pickupDate: Date
    $cargoTypeId: Int
  ) {
    createOrder(
      input: {
        order: {
          shipmentId: $shipmentId
          sellerId: $sellerId
          loadAtId: $loadAtId
          buyerId: $buyerId
          shipperId: $shipperId
          packingCode: $packingCode
          packingId: $packingId
          boxes: $boxes
          boxesControle: $boxesControle
          brutto: $brutto
          netto: $netto
          chargableWeight: $chargableWeight
          awb: $awb
          hawb: $hawb
          flight: $flight
          countryId: $countryId
          amountPallets: $amountPallets
          pickupDate: $pickupDate
          cargoTypeId: $cargoTypeId
        }
      }
    ) {
      order {
        id
        shipmentId
      }
    }
  }
`;

const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps)(ImportTransitDialog);



// WEBPACK FOOTER //
// ./src/common/Forms/_ImportTransitDialog.js